/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.preLoad)();
	  (0, _module.anchorLink)();
	  (0, _module.pickupSlider)();
	  (0, _module.toggleMenu)();
	  (0, _module.sideToggle)();
	  (0, _module.loadingToggle)();
	  (0, _module.parallax)();
	  (0, _module.charaHover)();
	  (0, _module.scrollAnim)();
	  (0, _module.loadAnim)();
	  (0, _module.animParticle)();
	})(); // Index Cloud Animation
	
	
	var animClouds = function animClouds(target) {
	  var elm = document.getElementById(target);
	  var elmHeight = elm.clientHeight;
	  var windowWidth = window.innerWidth;
	  var app = new PIXI.Application({
	    width: 1920,
	    height: 1084,
	    transparent: true
	  });
	  elm.appendChild(app.view);
	  app.stage.interactive = true;
	  var container = new PIXI.Container();
	  app.stage.addChild(container);
	  var texture = PIXI.Texture.from('/wp/wp-content/themes/nine-project/assets/images/common/common/bg_cloud.png');
	  var clouds = new PIXI.TilingSprite(texture);
	  container.addChild(clouds);
	  var displacementSprite = PIXI.Sprite.from('/wp/wp-content/themes/nine-project/assets/images/common/common/filter_map.jpg');
	  displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
	  var displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite);
	  displacementFilter.padding = 0;
	  displacementSprite.position = clouds.position;
	  app.stage.addChild(displacementSprite);
	  clouds.filters = [displacementFilter];
	  displacementFilter.scale.x = 0.05 * app.renderer.width;
	  displacementFilter.scale.y = 0.05 * app.renderer.width;
	  app.ticker.add(function () {
	    displacementSprite.x += 0.75;
	    clouds.tilePosition.x += 0.25;
	
	    if (displacementSprite.x > displacementSprite.width) {
	      displacementSprite.x = 0;
	    }
	  });
	  $(window).on("load resize", function () {
	    app.renderer.resize(window.innerWidth, window.innerHeight);
	    clouds.width = 3800 / 1920 * app.screen.width;
	    clouds.height = app.screen.height; // clouds.tileScale.x = window.innerWidth / 1920;
	
	    clouds.tileScale.y = window.innerHeight / 1084;
	  });
	};
	
	var userAgent = window.navigator.userAgent.toLowerCase();
	
	if (/iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document || userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {} else {// animClouds("mainvisual");
	}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.charaHover = exports.parallax = exports.loadingToggle = exports.sideToggle = exports.animParticle = exports.gameGallery = exports.changeCostume = exports.toggleMenu = exports.pickupSlider = exports.goodsGallery = exports.toggleParticles = exports.loadAnim = exports.scrollAnim = exports.anchorLink = exports.preLoad = void 0;
	var breakPoint = 767;
	var resizeFlag = false;
	var animatedFlag = 0;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	
	function getParam(name, url) {
	  if (!url) url = window.location.href;
	  name = name.replace(/[\[\]]/g, "\\$&");
	  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	      results = regex.exec(url);
	  if (!results) return null;
	  if (!results[2]) return '';
	  return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
	
	var getCookie = function getCookie() {
	  var arr = [];
	
	  if (document.cookie) {
	    var tmp = document.cookie.split('; ');
	
	    for (var i = 0; i < tmp.length; i++) {
	      var data = tmp[i].split('=');
	      arr[data[0]] = decodeURIComponent(data[1]);
	    }
	  }
	
	  return arr;
	};
	
	SmoothScroll({
	  stepSize: 60,
	  pulseScale: 4
	});
	$(function () {
	  $(window).on('beforeunload', function () {
	    if (matchMedia('(max-width: 798px)').matches) {
	      $("#particles").addClass("opacity");
	    }
	  });
	}); // $(window).on('beforeunload', function() {
	//
	// });
	// ------------------------------------------------------------------------
	// preLoad
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var preLoad = function preLoad() {
	  $(window).on("load", function () {
	    $("body").removeClass("preload");
	    $("body").css("opacity", "1");
	  });
	  setTimeout(function () {
	    $("body").removeClass("preload");
	  }, 9000);
	  setTimeout(function () {
	    $("body").css("opacity", "1");
	  }, 9000);
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preLoad = preLoad;
	
	var anchorLink = function anchorLink() {
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "swing");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// scrollAnimate
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var scrollAnim = function scrollAnim() {
	  $(window).on('scroll load', function () {
	    $('.anim-sc').each(function () {
	      var targetPos = $(this).offset().top;
	      var scrollPos = $(window).scrollTop();
	      var windowHeight = $(window).height();
	
	      if (scrollPos > targetPos - windowHeight + windowHeight / 4) {
	        $(this).addClass("animated");
	      }
	    });
	  });
	}; // ------------------------------------------------------------------------
	// loadAnimate
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.scrollAnim = scrollAnim;
	
	var loadAnim = function loadAnim() {
	  $(window).on('load', function () {
	    $('.anim-ld').each(function () {
	      var target = $(this);
	      $(this).addClass("animated");
	      setTimeout(function () {
	        $(target).removeClass("anim-ld");
	      }, 400);
	    });
	  });
	}; // ------------------------------------------------------------------------
	// toggleParticles
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.loadAnim = loadAnim;
	
	var toggleParticles = function toggleParticles() {
	  $(window).on("load scroll", function () {
	    var scrollHeight = $(this).scrollTop();
	
	    if (scrollHeight > windowHeight) {
	      $("#particles").addClass("scrolled");
	    } else {
	      $("#particles").removeClass("scrolled");
	    }
	  });
	}; // ------------------------------------------------------------------------
	// goodsGallery
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleParticles = toggleParticles;
	
	var goodsGallery = function goodsGallery() {
	  $('.slider-gallery').slick({
	    arrows: false,
	    dots: true,
	    infinite: false,
	    speed: 500,
	    fade: true,
	    cssEase: 'ease',
	    customPaging: function customPaging(slick, index) {
	      var targetImage = slick.$slides.eq(index).attr('data-src');
	      return '<button style="background:url(' + targetImage + ') no-repeat center center/contain"/>';
	    }
	  });
	}; // ------------------------------------------------------------------------
	// pickupSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.goodsGallery = goodsGallery;
	
	var pickupSlider = function pickupSlider() {
	  $('.slider-pickup').slick({
	    slidesToShow: 2,
	    slidesToScroll: 1,
	    arrows: true,
	    dots: true,
	    speed: 500,
	    cssEase: 'ease',
	    variableWidth: true,
	    appendArrows: '#slider-nav',
	    appendDots: '#slider-nav_dots ',
	    prevArrow: '<button class="slick-prev slick-arrow"></button>',
	    nextArrow: '<button class="slick-next slick-arrow"></button>',
	    responsive: [{
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 1,
	        swipeToSlide: true,
	        swipe: true,
	        edgeFriction: 0.01
	      }
	    }]
	  });
	}; // ------------------------------------------------------------------------
	// toggleMenu
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.pickupSlider = pickupSlider;
	
	var toggleMenu = function toggleMenu() {
	  $('.st-Header_Fixed .hamburger button').on('click', function () {
	    $(this).toggleClass("open");
	    $(".st-Header_Fixed nav").toggleClass("open");
	  });
	}; // ------------------------------------------------------------------------
	// changeCostume
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleMenu = toggleMenu;
	
	var changeCostume = function changeCostume() {
	  $('.costume-change').on('click', function () {
	    $('.costume-change').each(function (i) {
	      if ($(this).hasClass('current')) {
	        $(this).removeClass("current");
	      }
	    });
	    $('.character-image').each(function (i) {
	      if ($(this).hasClass('current')) {
	        $(this).removeClass("current");
	      }
	    });
	    var number = '.costume-' + $(this).data('number'); // console.log(number);
	
	    $(this).toggleClass("current");
	    $(number).toggleClass("current");
	  });
	}; // ------------------------------------------------------------------------
	// gameGallery
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.changeCostume = changeCostume;
	
	var gameGallery = function gameGallery() {
	  var targetSrc = "";
	  var targetIndex = "";
	  var trg = 0;
	  $('.gallery-viewer li').each(function (i) {
	    targetSrc = $(this).children('a').data('src');
	    $('.sw-Modal_Gallery').append('<li><img src="' + targetSrc + '"></li>');
	  });
	  $('.gallery-viewer.special a').each(function (i) {
	    targetSrc = $(this).data('src');
	    $('.sw-Modal_Gallery').append('<li><img src="' + targetSrc + '"></li>');
	  });
	
	  if ($('.sw-Modal_Gallery').hasClass('special')) {
	    $('.sw-Modal_Gallery').slick({
	      arrows: false,
	      dots: false,
	      infinite: false,
	      speed: 400,
	      fade: true,
	      cssEase: 'ease',
	      swipe: false
	    });
	  } else {
	    $('.sw-Modal_Gallery').slick({
	      arrows: true,
	      infinite: false,
	      speed: 400,
	      fade: true,
	      cssEase: 'ease',
	      appendArrows: '#slider-nav',
	      prevArrow: '<button class="slick-prev slick-arrow"></button>',
	      nextArrow: '<button class="slick-next slick-arrow"></button>'
	    });
	  }
	
	  $('.gallery-viewer a').on('click', function () {
	    trg = 1;
	    targetIndex = $(this).data('index');
	    $('.sw-Modal').toggleClass('open');
	    $('.sw-Modal_Gallery').slick('slickGoTo', targetIndex, true); // console.log(targetIndex);
	  });
	  $('.sw-Modal_Close , .sw-Modal_Base').on('click', function () {
	    trg = 0;
	    $(".sw-Modal").toggleClass("open");
	  });
	}; // ------------------------------------------------------------------------
	// sideToggle
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.gameGallery = gameGallery;
	
	var sideToggle = function sideToggle() {
	  $(window).on("load scroll", function () {
	    var footerPos = $("#st-Footer").offset().top - 800;
	    var scrollHeight = $(this).scrollTop();
	
	    if (scrollHeight > footerPos) {
	      $(".st-Header_Fixed_Inner .official,.st-Header_Fixed_Inner .logos .text").addClass("hidden");
	    } else {
	      $(".st-Header_Fixed_Inner .official,.st-Header_Fixed_Inner .logos .text").removeClass("hidden");
	    }
	  });
	}; // ------------------------------------------------------------------------
	// loadingToggle
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.sideToggle = sideToggle;
	
	var loadingToggle = function loadingToggle() {
	  $('.st-Loading').height(windowHeight);
	  $(window).on('load', function () {
	    $('.st-Container').css('visibility', 'visible');
	    $('.st-Loading').toggleClass('exit');
	    setTimeout(function () {
	      $('.st-Loading').css('display', 'none');
	    }, 600);
	  });
	}; // ------------------------------------------------------------------------
	// parallax
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.loadingToggle = loadingToggle;
	
	var parallax = function parallax() {
	  if (/iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document) {} else {
	    var rellax = new Rellax('.lax', {
	      breakpoints: [576, 768, 1201]
	    });
	  }
	}; // ------------------------------------------------------------------------
	// charaHover
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.parallax = parallax;
	
	var charaHover = function charaHover() {
	  if (/iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document) {} else {
	    var target = '';
	    $('.chara-button li a').hover(function () {
	      var target = $(this).data('chara');
	      $('.chara-image').toggleClass('hover');
	      $(target).toggleClass('hover');
	    }, function () {
	      var target = $(this).data('chara');
	      $('.chara-image').toggleClass('hover');
	      $(target).toggleClass('hover');
	    });
	  }
	}; // ------------------------------------------------------------------------
	// animParticle
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.charaHover = charaHover;
	
	var animParticle = function animParticle() {
	  PIXI.settings.CAN_UPLOAD_SAME_BUFFER = false;
	
	  var animParticles = function animParticles(target, img) {
	    var elm = document.getElementById(target);
	    var elmHeight = elm.clientHeight;
	    var windowWidth = window.innerWidth;
	    var windowHeight = window.innerHeight;
	    var mouse = {
	      x: 0,
	      y: 0
	    };
	    var exTrg = 0;
	    var exEndTrg = 0;
	    var beforePos = 0;
	    var app = new PIXI.Application({
	      width: windowWidth,
	      height: windowHeight,
	      transparent: true,
	      preserveDrawingBuffer: true
	    });
	    app.stage.interactive = true;
	    elm.appendChild(app.view);
	    var sprites = new PIXI.ParticleContainer(30, {
	      scale: true,
	      position: true,
	      alpha: true,
	      autoResize: true
	    });
	    app.stage.addChild(sprites);
	    var particles = [];
	    var spritesValue = '';
	
	    if (matchMedia('(max-width: 798px)').matches) {
	      spritesValue = 15;
	    } else {
	      spritesValue = 30;
	    }
	
	    var totalSprites = app.renderer instanceof PIXI.Renderer ? spritesValue : spritesValue;
	    var alphaflags = [];
	    var alphaflag;
	
	    for (var i = 0; i < totalSprites; i++) {
	      // create a new Sprite
	      var particle = PIXI.Sprite.from(img);
	      particle.tint = 0xC6F2FF;
	      particle.anchor.set(0.5);
	
	      if (windowWidth > 768) {
	        particle.scale.set(0.1 + Math.random() * 0.4);
	      } else {
	        particle.scale.set(0.1 + Math.random() * 0.2);
	      }
	
	      particle.x = Math.random() * app.screen.width;
	      particle.y = Math.random() * app.screen.height;
	      particle.direction = Math.random() * Math.PI * 2;
	      particle.turningSpeed = Math.random() - 0.8;
	      particle.speed = (2 + Math.random() * 2) * 0.2;
	      particle.offset = Math.random() * 100;
	      particle.alpha = Math.random() * 0.4;
	      particles.push(particle);
	      sprites.addChild(particle);
	      var _alphaflag = 2;
	      alphaflags.push(_alphaflag);
	    }
	
	    function onPointerMove(e) {
	      mouse.x = e.data.global.x;
	      mouse.y = e.data.global.y;
	    }
	
	    app.stage.on('mousemove', onPointerMove).on('touchmove', onPointerMove);
	    var particleBoundsPadding = 100;
	    var particleBounds = new PIXI.Rectangle(-particleBoundsPadding, -particleBoundsPadding, app.screen.width + particleBoundsPadding * 2, app.screen.height + particleBoundsPadding * 2);
	    var tick = 0;
	    app.ticker.add(function () {
	      for (var _i = 0; _i < particles.length; _i++) {
	        var _particle = particles[_i];
	        _particle.direction += _particle.turningSpeed * 0.01;
	        _particle.x += Math.sin(_particle.direction) * (_particle.speed * _particle.scale.y);
	        _particle.y += Math.cos(_particle.direction) * (_particle.speed * _particle.scale.y);
	        _particle.rotation = -_particle.direction + Math.PI; // opacity
	
	        if (_particle.alpha > 0.3) {
	          alphaflags[_i] = 1;
	        } else if (_particle.alpha < 0.01) {
	          alphaflags[_i] = 0;
	        }
	
	        if (alphaflags[_i] == 1) {
	          _particle.alpha -= 0.005 * _particle.speed;
	        } else if (alphaflags[_i] == 0 || alphaflags[_i] == 2) {
	          _particle.alpha += 0.005 * _particle.speed;
	        } // overflow
	
	
	        if (_particle.x < particleBounds.x) {
	          _particle.x += particleBounds.width;
	        } else if (_particle.x > particleBounds.x + particleBounds.width) {
	          _particle.x -= particleBounds.width;
	        }
	
	        if (_particle.y < particleBounds.y) {
	          _particle.y += particleBounds.height;
	        } else if (_particle.y > particleBounds.y + particleBounds.height) {
	          _particle.y -= particleBounds.height;
	        } // mouse
	
	
	        if (mouse.x - _particle.x < 50 && mouse.x - _particle.x > -50 && mouse.y - _particle.y < 50 && mouse.y - _particle.y > -50) {
	          _particle.x += (mouse.x - _particle.x) * _particle.speed * 0.01;
	          _particle.y += (mouse.y - _particle.y) * _particle.speed * 0.01;
	        }
	      }
	
	      tick += 0.1;
	    });
	    $(window).on("load resize", function () {
	      app.renderer.resize(window.innerWidth, window.innerHeight);
	      particleBounds.width = app.screen.width + particleBoundsPadding * 2;
	      particleBounds.height = app.screen.height + particleBoundsPadding * 2;
	    });
	    $(window).on("scroll", function () {
	      var scrollHeight = $(this).scrollTop();
	
	      for (var _i2 = 0; _i2 < particles.length; _i2++) {
	        var _particle2 = particles[_i2];
	
	        if (scrollHeight > beforePos) {
	          _particle2.y -= 6 * _particle2.scale.y;
	        } else {
	          _particle2.y += 6 * _particle2.scale.y;
	        }
	      }
	
	      beforePos = scrollHeight;
	    });
	  };
	
	  var userAgent = window.navigator.userAgent.toLowerCase();
	
	  if (/iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document || userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {} else {
	    animParticles('particles', '/wp/wp-content/themes/nine-project/assets/images/common/bg_particle.png');
	  }
	};
	
	exports.animParticle = animParticle;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js